import { type FunctionComponent } from 'react';

import { useCardId } from '@trello/id-context';

import { useIsCardMarkedComplete } from 'app/src/components/CardDoneState/useIsCardMarkedComplete';
import { CardFrontArchiveButton } from 'app/src/components/CardFront/CardFrontArchiveButton';
import { MirrorCardExpandToggle } from './MirrorCardExpandToggle';
import { MirrorCardFeedback } from './MirrorCardFeedback';
import { useMirrorCardFragment } from './MirrorCardFragment.generated';
import { useMirrorCardSourceId } from './useMirrorCardSourceId';

interface MirrorCardActionsProps {
  canShowArchiveButton: boolean;
}

export const MirrorCardActions: FunctionComponent<MirrorCardActionsProps> = ({
  canShowArchiveButton,
}) => {
  const cardId = useCardId();

  const { data: card } = useMirrorCardFragment({
    from: { id: cardId },
  });

  const { mirrorCardSourceId, mirrorCardError } = useMirrorCardSourceId(
    card?.name ?? '',
    cardId,
  );

  const isComplete = useIsCardMarkedComplete(mirrorCardSourceId ?? '');
  const isArchiveButtonVisible = canShowArchiveButton && isComplete;

  return (
    !mirrorCardError && (
      <>
        {isArchiveButtonVisible && <CardFrontArchiveButton />}
        <MirrorCardExpandToggle /> <MirrorCardFeedback />
      </>
    )
  );
};
